(() => {
  const mobile = window.matchMedia("(max-width: 749px)");
  const initialized = new WeakSet();

  async function initialize() {
    await customElements.whenDefined("slideshow-component");

    document
      .querySelectorAll("slideshow-component[data-mobile-card-swipe]")
      .forEach((gallery) => {
        if (initialized.has(gallery)) return;

        const card = gallery.closest(".card-gallery");
        const scroller = gallery.querySelector("slideshow-slides");
        if (!card || !scroller) return;

        initialized.add(gallery);

        const indicator = document.createElement("div");
        indicator.className = "mobile-card-swipe-indicator";
        indicator.setAttribute("aria-hidden", "true");

        const thumb = document.createElement("span");
        indicator.append(thumb);
        card.append(indicator);

        let startX = 0;
        let startY = 0;
        let swiped = false;
        let resetTimer;

        function updateIndicator() {
          const distance = scroller.scrollWidth - scroller.clientWidth;
          const progress = distance > 0
            ? Math.min(1, Math.abs(scroller.scrollLeft) / distance)
            : 0;

          const visibleSlides = [...gallery.querySelectorAll(
            "slideshow-slide"
          )].filter((slide) => !slide.hasAttribute("hidden"));

          const count = Math.max(visibleSlides.length, 1);
          const width = 100 / count;

          thumb.style.width = `${width}%`;
          thumb.style.left = `${progress * (100 - width)}%`;
          indicator.hidden = !mobile.matches || distance < 2;
        }

        function applyMode() {
          gallery.disabled = !mobile.matches;
          card.classList.toggle("mobile-card-swipe-enabled", mobile.matches);

          requestAnimationFrame(updateIndicator);
        }

        scroller.addEventListener("scroll", updateIndicator, {
          passive: true
        });

        card.addEventListener("pointerdown", (event) => {
          if (!mobile.matches) return;

          clearTimeout(resetTimer);
          startX = event.clientX;
          startY = event.clientY;
          swiped = false;
        }, { passive: true });

        card.addEventListener("pointermove", (event) => {
          if (!mobile.matches) return;

          const horizontal = Math.abs(event.clientX - startX);
          const vertical = Math.abs(event.clientY - startY);

          if (horizontal > 10 && horizontal > vertical) {
            swiped = true;
          }
        }, { passive: true });

        card.addEventListener("pointerup", () => {
          resetTimer = setTimeout(() => {
            swiped = false;
          }, 400);
        }, { passive: true });

        card.addEventListener("click", (event) => {
          if (!mobile.matches || !swiped) return;

          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);

        mobile.addEventListener("change", applyMode);
        new ResizeObserver(updateIndicator).observe(scroller);

        requestAnimationFrame(applyMode);
      });
  }

  initialize();

  document.addEventListener("shopify:section:load", initialize);

  new MutationObserver(() => initialize()).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
